import styled from 'styled-components';

export const Box = styled.div`
  width: 100%;
  padding: 1rem;
  margin: auto;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 3rem;
`;

export const TextRed = styled.span`
  font-size: 15px;
  color: #df88a6;
  font-weight: 600;
`;
